import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Typography,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import UsersListGrid from "../../components/usersListGrid";
import UserRegistrationDialog from "../../components/UserRegistrationDialog";
import ResetPasswordDialog from "../../components/ResetPasswordDialog";
import EmailHistoryDialog from "../../components/EmailHistoryDialog";
import { getDealerRegistrationList } from "../../services/dealerRegisterServices";
import { AuthContext } from "../../AuthContext";

const UsersCard = (props) => {
    const { APP_ENV } = useContext(AuthContext);
  // const { sx } = props;
  const [openRegDialog, setOpenRegDialog] = useState(false);
  const [openPwdDialog, setOpenPwdDialog] = useState(false);
  const [chgPwdEmail, setChgPwdEmail] = useState("");
  const [openEmailLogDialog, setOpenEmailLogDialog] = useState(false);
  const [emailLogUser, setEmailLogUser] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [userData, setUserData] = useState("");

  const [usersList, setUserList] = useState([]);
  // A failed fetch leaves usersList empty, and the export dialog would then state
  // "0 users will be exported" -- an affirmative claim about mailability built out
  // of a request that never landed. Distinguish "nobody" from "we do not know".
  const [loadError, setLoadError] = useState(false);

  const getUsersList = () => {
    getDealerRegistrationList()
      .then(
        (res) => {
          const data = res.data;
          setLoadError(false);
          if (data && data.length > 0) {
            const tempUserList = data.map((user) => {
              //console.log("usercard load uuser :", user);
              return {
                id: user.id,
                dealerName: user.dealerName ? user.dealerName : "Admin User",
                dealerId: user.dealerId === 0 ? "" : user.dealerId,
                dealerAvatar: user.dealerAvatar,
                isActive: user.isActive,
                isPrimary:user.isPrimary,
                emailOptIn:user.emailOptIn,
                // The dealer's ST export status, same value for every user under one dealer.
                exportStatus: user.exportStatus,
                registeredName: user.registeredName,
                registeredEmail: user.registeredEmail,
                userRole: user.dealerId ? "Dealer" : "Admin",
                createdDate: user.createdOn,
                tenantId:user.tenantId,
                businessUnit:user.businessUnit,
                emailOptInFrequency:user.emailOptInFrequency,
                TenantsDetails:user.TenantsDetails ? APP_ENV==="Development" ? JSON.parse(user.TenantsDetails) : user.TenantsDetails : []
              };
            });
            setUserList(tempUserList);
          } else {
            setUserList([]);
          }
        },
        (err) => {
          console.log("users list data loading error :", err);
          setLoadError(true);
        }
      )
      .catch((err) => {
        console.error("user list server error", err);
        setLoadError(true);
      });
  };

  useEffect(() => {
    getUsersList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleRegDialogClose = (data) => {
    if (data === "userCreated") {
      getUsersList();
    }
    setOpenRegDialog(false);
  };

  const handleRegDialogOpen = () => {
    setUserData("");
    setIsEdit(false);
    setOpenRegDialog(true);
  };

  const handlePwdDialogClose = (e) => {
    //console.log("pwd dialog close :", e);
    setIsEdit(false);
    setOpenPwdDialog(false);
  };

  const handlePwdDialogOpen = () => {
    setOpenPwdDialog(true);
  };

  const handleEditUser = (data) => {
    //console.log("userCard  Edit:", data);
    const {
      id,
      dealerId,
      tenantId,
      businessUnit,
      dealerName,
      registeredName,
      registeredEmail,
      isActive,
      isPrimary,
      emailOptIn,
      userRole,
      TenantsDetails,
      emailOptInFrequency,
    } = data;
    const editUser = {
      id: id,
      dealerId: dealerId,
      tenantId: tenantId,
      businessUnit:businessUnit,
      companyName: dealerName,
      fullName: registeredName,
      email: registeredEmail,
      roleValue: userRole,
      isActive: isActive,
      isPrimary:isPrimary,
      emailOptIn:emailOptIn,
      emailOptInFrequency:emailOptInFrequency,
      TenantsDetails:TenantsDetails,
    };
    setUserData(editUser);
    setIsEdit(true);
    setOpenRegDialog(true);
  };
  const handlePasswordChange = (data) => {
    console.log("userCard  change password :", data);
    setChgPwdEmail(data.registeredEmail);
    handlePwdDialogOpen();
  };

  const handleViewEmailLog = (data) => {
    setEmailLogUser(data);
    setOpenEmailLogDialog(true);
  };

  const handleEmailLogDialogClose = () => {
    setOpenEmailLogDialog(false);
    // Clear the selection too: leaving it set lets the next open render the previous
    // user's email history under the new user's name until the fetch resolves.
    setEmailLogUser(null);
  };

  return (
    <Card sx={{ borderRadius: 3 }} raised={true}>
      <CardContent sx={{ p: 2 }}>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={12} lg={12}>
            <UserRegistrationDialog
              open={openRegDialog}
              onClose={handleRegDialogClose}
              isEdit={isEdit}
              userData={userData}
            />
            <ResetPasswordDialog
              open={openPwdDialog}
              onClose={handlePwdDialogClose}
              registeredEmail={chgPwdEmail}
            />
            <EmailHistoryDialog
              open={openEmailLogDialog}
              onClose={handleEmailLogDialogClose}
              user={emailLogUser}
            />
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} lg={12}>
                <Box
                  sx={{
                    width: "100%",
                    padding: 1,
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <Typography variant="h6" component="h6">
                    All Users <br />
                    {/* <Typography
                      variant="body2"
                      component="div"
                      sx={{ color: "#a8a8a8d4" }}
                    >
                      Showing 5 out of 5
                    </Typography> */}
                  </Typography>
                  <Box sx={{ flexGrow: 1 }} />
                  <Box>
                    <Button
                      variant="contained"
                      color="secondary"
                      size="small"
                      sx={{
                        borderRadius: "50px",
                      }}
                      onClick={handleRegDialogOpen}
                    >
                      Add New User
                    </Button>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} lg={12}>
            {loadError && (
              <Alert severity="error" sx={{ mb: 1 }}>
                Could not load the user list. Refresh to try again.
              </Alert>
            )}
            <UsersListGrid
              editUser={handleEditUser}
              onPasswordChange={handlePasswordChange}
              onViewEmailLog={handleViewEmailLog}
              usersList={usersList}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default UsersCard;
